import {
  __async
} from "./chunk--chunk-RQ7252KT.js";

// src/js/components/Accordion.js
var Accordion = class {
  constructor(el) {
    this.el = el;
  }
  init() {
    return __async(this, null, function* () {
      let HandyCollapse = yield import("./chunk--handy-collapse-NRFSGLOA.js");
      HandyCollapse = HandyCollapse.default;
      this.accordion = new HandyCollapse();
      document.querySelectorAll("[data-hc-body-click-toggle]").forEach((el) => {
        document.body.addEventListener("click", (e) => {
          if (!e.target.closest("[data-hc-control]") && !e.target.closest("[data-hc-content]")) {
            this.accordion.close(el.getAttribute("data-hc-body-click-toggle"));
          }
        });
      });
      document.addEventListener("accordion close", (e) => {
        this.accordion.close(e.detail.accordion, false, false);
      });
      setTimeout(() => {
        this.el.parentNode.querySelector("[data-hc-content]").style.visibility = "visible";
      }, 250);
    });
  }
};
var Accordion_default = Accordion;
export {
  Accordion_default as default
};
